import { Component, Input } from '@angular/core';
import {
  DAILY_DIGEST_TYPE,
  EXECUTIVE_REPORT_TYPE,
  GLOBAL_SETTINGS_TYPE,
  INSTANT_EMAIL_SECTION_TYPE,
} from '../../constants';
import {
  AccountGroupNotificationsService,
  AppSettingSection,
  ProductNotifications,
} from '../account-group-notifications.service';
const SORT_ORDER = [EXECUTIVE_REPORT_TYPE, INSTANT_EMAIL_SECTION_TYPE, DAILY_DIGEST_TYPE].reverse(); // Reversing so it orders it in the needed way for the sort function

export interface NotificationSection {
  sectionType: string;
  name: string;
  sections: AppSettingSection[];
}

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.scss'],
})
export class NotificationSettingsComponent {
  @Input()
  accountGroupId: string;
  @Input()
  subjectId: string;
  @Input()
  set product(product: ProductNotifications) {
    this._product = product;

    this.sectionsToDisplay = [];
    product.sections.forEach((section) => {
      const notifSection = this.sectionsToDisplay.find(
        (secToDisplay) => secToDisplay.sectionType === section.sectionType,
      );
      if (notifSection) {
        notifSection.sections.push(section);
      } else {
        this.sectionsToDisplay.push({
          sectionType: section.sectionType,
          name: this.convertSectionTypeToKey(section.sectionType),
          sections: [section],
        });
      }
    });
    this.sectionsToDisplay.sort(function (a: NotificationSection, b: NotificationSection): number {
      if (SORT_ORDER.indexOf(a.sectionType) * -1 < SORT_ORDER.indexOf(b.sectionType) * -1) {
        return -1;
      } else if (SORT_ORDER.indexOf(a.sectionType) * -1 > SORT_ORDER.indexOf(b.sectionType) * -1) {
        return 1;
      }
      return 0;
    });
  }
  _product: ProductNotifications;
  @Input()
  disabledSections: string[];

  sectionsToDisplay: NotificationSection[] = [];

  constructor(private accountGroupNotificationService: AccountGroupNotificationsService) {}

  updateSetting(section: AppSettingSection, sectionName: string, checked: boolean): void {
    const sectionNameToUse = sectionName === GLOBAL_SETTINGS_TYPE ? section.sectionId : sectionName;

    let sectionToUpdate;
    const splitSections = section.sectionId.split(':');

    if (splitSections.length > 2) {
      sectionToUpdate = this.sectionsToDisplay
        .find((sectionToDisplay) => sectionToDisplay.sectionType === sectionName)
        .sections.find((notifSection) => notifSection.sectionId === `${splitSections[0]}:${splitSections[1]}`)
        .children.find((childrenSection) => childrenSection.sectionId === section.sectionId);
    } else {
      sectionToUpdate = this.sectionsToDisplay
        .find((sectionToDisplay) => sectionToDisplay.sectionType === sectionName)
        .sections.find((notifSection) => notifSection.sectionId === section.sectionId);
    }

    sectionToUpdate.value = checked;
    this.accountGroupNotificationService
      .updateSectionSetting(this.accountGroupId, this.subjectId, sectionNameToUse, section.sectionId, checked)
      .subscribe();
  }

  private convertSectionTypeToKey(sectionType: string): string {
    if (sectionType === INSTANT_EMAIL_SECTION_TYPE) {
      return 'USER_NOTIFICATIONS.INSTANT_EMAIL';
    }
    if (sectionType === DAILY_DIGEST_TYPE) {
      return 'USER_NOTIFICATIONS.DAILY_DIGEST';
    }
    if (sectionType === EXECUTIVE_REPORT_TYPE) {
      return 'USER_NOTIFICATIONS.EXECUTIVE_REPORT';
    }
    return sectionType;
  }
}
